export const css = {
	root: '_1D_TvnuH',
	' _key': 'apic-theme/apic/variants/ltccip1'
};

export default css;
